<script>
// Presentational shell shared by bottom-left promo cards. Eligibility and
// persistence live in the wrapping promo components; this only renders.
export default {
  name: "PromoCard",
  props: {
    show: { type: Boolean, default: false },
    ariaLabel: { type: String, required: true },
    eyebrow: { type: String, required: true },
    title: { type: String, required: true },
    ctaText: { type: String, required: true },
    dismissLabel: { type: String, default: "Dismiss" },
  },
};
</script>

<template>
  <transition name="promo-card">
    <div v-if="show" class="promo-card" role="complementary" :aria-label="ariaLabel">
      <button
        type="button"
        class="promo-close"
        @click="$emit('dismiss')"
        :aria-label="dismissLabel"
        title="Dismiss"
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div class="promo-eyebrow">
        <slot name="eyebrow-icon"></slot>
        <span>{{ eyebrow }}</span>
      </div>
      <div class="promo-title">{{ title }}</div>
      <p class="promo-copy"><slot></slot></p>
      <button type="button" class="promo-cta" @click="$emit('cta')">{{ ctaText }}</button>
    </div>
  </transition>
</template>

<style scoped>
.promo-card {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1029; /* under the fixed navbar (1030) and modals */
  width: 300px;
  padding: 16px 16px 14px;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 12px 32px -12px rgba(8, 11, 13, 0.25);
}
.promo-close {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #9ca3af;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}
.promo-close:hover {
  background: rgba(15, 23, 42, 0.06);
  color: #111827;
}
.promo-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #017a48;
  margin-bottom: 6px;
}
.promo-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}
.promo-copy {
  font-size: 12.5px;
  line-height: 1.5;
  color: #4b5563;
  margin: 0 0 12px;
}
.promo-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 14px;
  background: #019256;
  border: 0;
  border-radius: 6px;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background-color 120ms ease;
}
.promo-cta:hover {
  background: #017a48;
}

/* Enter/leave */
.promo-card-enter-active,
.promo-card-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}
.promo-card-enter,
.promo-card-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
@media (prefers-reduced-motion: reduce) {
  .promo-card-enter-active,
  .promo-card-leave-active {
    transition: none;
  }
}

@media (max-width: 575px) {
  .promo-card {
    left: 12px;
    right: 12px;
    bottom: 12px;
    width: auto;
  }
}
</style>
